import Vue from 'vue'

const STORIES = {
	LIST: filter => {
		return Vue.$api.get('/stories', { params: { filter: filter } })
	},
	COUNT: where => {
		return Vue.$api.get('/stories/count', { params: where })
	},
}

export default STORIES
